import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Database, ArrowRight } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    icon: <Phone className="w-8 h-8 text-brand-accent" data-id="element-142" />,
    title: 'Anruf geht ein',
    description: 'vox space nimmt jeden Anruf automatisch entgegen — 24/7.'
  }, {
    icon: <Mail className="w-8 h-8 text-brand-accent" data-id="element-143" />,
    title: 'Zusammenfassung per E-Mail',
    description: 'Sie erhalten sofort eine strukturierte Zusammenfassung: Anrufer, Anliegen, Rückrufnummer.'
  }, {
    icon: <Database className="w-8 h-8 text-brand-accent" data-id="element-144" />,
    title: 'Live-Protokoll im Dashboard (Opt.)',
    description: 'Jeder Anruf wird automatisch in einer Online-Liste dokumentiert. Von überall aus abrufbar.'
  }];
  return <section className="py-20 bg-brand-gray" id="funktionen" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-148">
            So funktioniert vox space
          </motion.h2>
        </div>

        <div data-id="element-149">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-150">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center relative" data-id="element-151">
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-lg border-4 border-brand-gray mb-6 relative z-10" data-id="element-152">
                  {step.icon}
                </div>

                <h3 className="text-xl font-bold text-brand-dark mb-3 bg-brand-gray px-2" data-id="element-153">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-154">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}